import SvgMinusMEP from '@img/icons/minus-mep.svg';
import SvgMinus from '@img/icons/minus.svg';
import SvgPlusMEP from '@img/icons/plus-mep.svg';
import SvgPlus from '@img/icons/plus.svg';
import FormField from '@stories/Components/Global/Forms/FormField';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './QuantitySelector.styles';
const QuantitySelector = ({ min = 1, ...props }) => {
    return (React.createElement(S.Container, { "aria-disabled": props.disabled, "data-site": props.site },
        React.createElement(FormField, { name: "qty", label: "Qty", required: true },
            React.createElement(S.Inner, null,
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.Button, { disabled: props.disabled || props.value === min, onClick: props.onDownPress, "aria-label": "Decrease" }, props.site === 'mep' ? React.createElement(SvgMinusMEP, null) : React.createElement(SvgMinus, null))),
                React.createElement(S.Value, null, props.value),
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.Button, { disabled: props.disabled || props.value === props.max, onClick: props.onUpPress, "aria-label": "Increase" }, props.site === 'mep' ? React.createElement(SvgPlusMEP, null) : React.createElement(SvgPlus, null)))))));
};
export default QuantitySelector;
